import { Pipe, PipeTransform } from '@angular/core';

/*
 * Convert lbs in stone and lbs
 * Takes a format argument that defaults to 'full'.
 * Usage:
 *   value | toStones:format
 * Examples:
 *   {{ 150 | toStones }}
 *   formats to: 10 St 19 lbs
 *   {{ 150 | toStones:'short' }}
 *   formats to: 10.10
*/
@Pipe({
  name: 'toStones'
})
export class ToStonesPipe implements PipeTransform {

  transform(value: Number|String, format: string): string {
    if (value && (typeof value === 'number') || (typeof value === 'string')) {
      let stones, lbs;
      if (typeof value === 'number') {
        // console.log('number', value)
        stones = Math.floor(value / 14);
        lbs = value % 14;
      }
      if (typeof value === 'string') {
        // console.log('string ...', value)
        const decimalPattern = /^\d+(\.\d{2})?$/;
        if (decimalPattern.test(value)) {
          // console.log('... has decimal', value)
          const valueFloat = parseFloat(value);
          stones = Math.floor(valueFloat / 14);
          lbs = valueFloat % 14;
        } else {
          // console.log('... not decimale', value)
          return value;
        }
      }
      if (format === 'short') {
        return `${stones}.${lbs}`;
      } else {
        return `${stones} St ${lbs} lbs`;
      }
    } else {
      // console.log('something unexpected, casting to string', value)
      return String(value);
    }
  }

}
